import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamYearlyGoalResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
};

const getTeamYearlyGoal = async (params: Params): Promise<TeamYearlyGoalResponse> => {
  const { data } = await api.get<TeamYearlyGoalResponse>(
    `${BI_BASE_URL}/managers/team/yearly/goal`,
    { params }
  );

  return data;
};

export const useGetTeamYearlyGoal = ({ year }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_YEARLY_GOAL, year],
    queryFn: () => {
      return getTeamYearlyGoal({ year });
    },
  });
};
